import { User } from './user';

export class Purpose {
  name!: string;
  description?: string;
  has_physical_examination!: boolean;
  has_warehouse_transaction!: boolean;
  has_container_transaction!: boolean;
  action?: string;
  daily_parking_cost!: number;
  daily_parking_cost_local?: number;
  daily_parking_cost_foreign?: number;
  first_calendar_date_cost?: number;
  /** The long-stay premium per night, the night it starts, and the export grace hours (#86). */
  parking_premium_rate?: number | null;
  parking_premium_after_nights?: number | null;
  grace_hours?: number | null;
  time_tolerance_in_hours!: number;
  parking_cost_after_tolerance_per_hour!: number;
  bill_per_calendar_date?: boolean;
  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;

  static getSortColumns() {
    return [
      'name',
      'description',
      'action',
      'email',
      'phone_number',
      'status',
    ];
  }


  constructor(data: any) {
    this.user_uuid = data.user_uuid;
    this.name = data.name;
    this.action = data.action;
    this.description = data.description;
    this.has_physical_examination = data.has_physical_examination;
    this.has_warehouse_transaction = data.has_warehouse_transaction;
    this.has_container_transaction = data.has_container_transaction;
    this.daily_parking_cost = data.daily_parking_cost;
    this.daily_parking_cost_local = data.daily_parking_cost_local;
    this.daily_parking_cost_foreign = data.daily_parking_cost_foreign;
    this.first_calendar_date_cost = data.first_calendar_date_cost;
    this.parking_premium_rate = data.parking_premium_rate ?? null;
    this.parking_premium_after_nights = data.parking_premium_after_nights ?? null;
    this.grace_hours = data.grace_hours ?? null;
    this.time_tolerance_in_hours = data.time_tolerance_in_hours;
    this.parking_cost_after_tolerance_per_hour = data.parking_cost_after_tolerance_per_hour;
    this.bill_per_calendar_date = data.bill_per_calendar_date;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
